
import { defineComponent, SetupContext, getCurrentInstance, onUnmounted, watch, onMounted, ref, nextTick } from 'vue';
import { formateNum, copyToClipboard, getQuery } from '@/common/utils'
import Like from '../svgs/like.vue';
import Comment from '../svgs/comment.vue';
import Share from '../svgs/share.vue';
import ShareDialog from '@/components/Share/index.vue';
import { sendLog } from '~/common/radar';
  
export default defineComponent({
    components: {
        Like,
        Comment,
        Share,
        ShareDialog,
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    },
    setup(props, ctx: SetupContext) {
        const { proxy } = getCurrentInstance() as any

        const showShare = ref<boolean>(false);

        const handleClick = (type: string) => {
            sendLog({
                type: 'click',
                name: 'INTERACT_AREA',
                value: {
                    author_id: props.item.kwai_id,
                    button_type: type
                }
            })
            if(type === 'share') {
                showShare.value = true;
            }
            else ctx.emit('action', type)
        }

        const handleShare = () => {
            showShare.value = false
        };

        return {
            handleClick,
            formateNum,
            handleShare,
            showShare,
        }
    },
    head() {
        return {
        }
    },
})
